import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { ArrowLeft } from "lucide-react";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      const pendingSession = localStorage.getItem("mep_pending_session");
      const u = await register(email, password, pendingSession);
      if (pendingSession) localStorage.removeItem("mep_pending_session");
      toast.success("Cuenta creada");
      if (u.payment_status !== "paid") navigate("/pago");
      else if (!u.has_profile) navigate("/crear-perfil");
      else navigate("/panel");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo crear la cuenta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--mep-black)] text-white mep-grain flex flex-col">
      <header className="px-5 md:px-10 py-5">
        <Link to="/" data-testid="register-back-link" className="flex items-center gap-2 text-sm text-[var(--mep-text-muted)] hover:text-white">
          <ArrowLeft size={16} /> Inicio
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-md">
          <div className="mep-pill-gold mb-4">Nueva cuenta</div>
          <h1 className="font-display text-4xl md:text-5xl font-light tracking-tighter mb-2">Crear cuenta</h1>
          <p className="text-[var(--mep-text-muted)] mb-8">Empieza tu transformación.</p>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Correo</label>
              <input
                data-testid="register-email-input"
                type="email"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Contraseña</label>
              <input
                data-testid="register-password-input"
                type="password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] mb-2 block">Confirmar contraseña</label>
              <input
                data-testid="register-confirm-input"
                type="password"
                value={confirm}
                required
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full bg-[var(--mep-surface)] border border-[var(--mep-border)] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--mep-pink)] transition"
              />
            </div>
            <button
              data-testid="register-submit-btn"
              type="submit"
              disabled={loading}
              className="btn-pink w-full py-4 font-semibold"
            >
              {loading ? "Creando cuenta..." : "Crear cuenta"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
